var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 16,
  fill: "none",
  viewBox: "0 0 14 16",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7 .5a4.167 4.167 0 0 0-2.778 7.273 6.67 6.67 0 0 0-3.889 6.06v.834a.833.833 0 0 0 1.667 0v-.834a5 5 0 0 1 10 0v.834a.833.833 0 0 0 1.666 0v-.834a6.67 6.67 0 0 0-3.889-6.06A4.167 4.167 0 0 0 7 .5M5.232 2.899a2.5 2.5 0 1 1 3.535 3.535A2.5 2.5 0 0 1 5.232 2.9",
  clipRule: "evenodd"
})));
export { SvgProfileIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/profileIcon.svg";